/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

import GLightbox from 'glightbox';
import 'glightbox/dist/css/glightbox.min.css';

import 'swiper/swiper-bundle.min.css';
import Alpine from "alpinejs";
import SwiperCore, {
    Swiper,
    Navigation,
    Pagination,
    Autoplay
} from "swiper/core";
SwiperCore.use([Navigation, Pagination, Autoplay]);

window.Swiper = Swiper;
import dayjs from "dayjs";
window.dayjs = dayjs;

import "cookieconsent";
const lightbox = GLightbox({
    touchNavigation: true,
    selector: '.glightbox'
});

import { fetchWithCsrf, toFormData, toastMessage } from "./fetcher";
window.fetchWithCsrf = fetchWithCsrf;
window.toFormData = toFormData;
window.toastMessage = toastMessage;



Alpine.store("cart", {
    items: JSON.parse(localStorage.getItem("cart")) ?? [],
    change: async function (item) {
        const index = this.items.findIndex(e => e.id === item.id);
        if (index >= 0) {
            const remaining =
                parseInt(this.items[index].amount) + parseInt(item.amount);
            if (remaining > 0) {
                this.items[index].amount = remaining;
            } else {
                if (
                    confirm(
                        "Ezzel törlöd a terméket a kosár tartalmából, folytatod?"
                    )
                ) {
                    this.items.splice(index, 1);
                }
            }
        } else {
            item.amount = parseInt(item.amount);
            this.items.push(item);
        }

        if (window.checkForCart) {
            const response = await fetchWithCsrf(route("saveCart"), {
                method: 'POST',
                body: {
                    products: this.items
                },
            });

            if (response.error) {
                return;
            }

            this.items = [];
            Object.keys(response.search).forEach(id => {
                this.items.push({
                    id: parseInt(id),
                    amount: parseInt(response.search[id])
                });
            });
            localStorage.setItem("cart", JSON.stringify(this.items));
        }

        localStorage.setItem("cart", JSON.stringify(this.items));

        document.querySelector(".toast #message").textContent = "Termék hozzáadva a kosárhoz";
        document.querySelector(".toast").classList.add("opacity-100");
        setTimeout(function () {
            document.querySelector(".toast").classList.remove("opacity-100");
        }, 2500);
    },
    checkFromServer: async function () {
        if (!window.checkForCart) {
            return;
        }
        const response = await fetchWithCsrf(route("cartContent"), {
            method: 'POST'
        });

        if (response.error) {
            return;
        }

        this.items = [];
        Object.keys(response.search).forEach(id => {
            this.items.push({
                id: parseInt(id),
                amount: parseInt(response.search[id])
            });
        });
        localStorage.setItem("cart", JSON.stringify(this.items));
    }
});

window.Alpine = Alpine;
Alpine.start();
